import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-finaly-defect-order-class-day',
  templateUrl: './finaly-defect-order-class-day.component.html',
  styleUrls: ['./finaly-defect-order-class-day.component.css'],
})
export class FinalyDefectOrderClassDayComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  message: string = '';
  @Output() errorEmitter = new EventEmitter();

  constructor(private api: ApiService) { }
  totalDefect: number = 0;
  dataSourceDefect: any = {
    chart: {
      theme: 'fusion',
      placevaluesinside: '0',
      maxBarHeight: '14',
      showValues: '1',
      showSum: '2',
      baseFontSize: '13',
    },
    categories: [
      {
        category: [],
      },
    ],
    dataSet: [],
  };
  loading: boolean = true;
  errorApi: boolean = false;
  typeClassificationDescription: string = '';
  dataLabel: string = '';
  inValue: boolean = false;

  ngOnInit(): void {
    this.typeClassificationDescription = '';
    this.errorEmitter.emit("Teste de erro");
  }

  filterItem(item: any) {
    this.totalDefect = 0;
    this.errorApi = false;
    this.loading = true;
    const currentDate = new Date();

    if (item.dataMin === '') item.dataMin.transform(currentDate, 'yyyy-MM-dd');

    if (item.dataMax === '') item.dataMax.transform(currentDate, 'yyyy-MM-dd');

    this.getOrderClassDefectInformation(item);
  }

  async getOrderClassDefectInformation(item: any) {
    if (!this.validateFilter(item)) return;
    this.dataSourceDefect.dataSet = [];
    var dataMin = new Date(item.dataMin);
    dataMin.setDate(dataMin.getDate() + 1);
    var dataMax = new Date(item.dataMax);
    dataMax.setDate(dataMax.getDate() + 1);
    this.dataLabel =
      dataMin.toLocaleDateString() + ' a ' + dataMax.toLocaleDateString();

    try {
      this.inValue = false;
      this.typeClassificationDescription =
        '- ' + item.typeClassificationDescription;
      const itemProductAux =
        item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];
      const result = await this.api
        .getOrderClassDefectInformation(
          item.dataMin,
          item.dataMax,
          Number(item.typeClassification),
          itemProductAux,
          item.branch
        )
        .toPromise();
      if (result.items.length != 0) {
        this.totalDefect = 0;
        this.dataSourceDefect.dataSet = [];
        this.dataSourceDefect.categories[0].category = [];

        result.items.sort((a: any, b: any) => b.totalDefect - a.totalDefect);

        const nonZeroItems = result.items.filter(
          (x: any) => Number(x.totalDefect) !== 0
        );
        const labels = nonZeroItems.map(
          (x: any) => x.classificationDescription
        );
        labels.forEach((itemFor: any) => {
          this.dataSourceDefect.categories[0].category.push({
            label: itemFor,
          });
        });

        const listAux = [
          {
            label: 'Sacrifício',
            property: 'sacrificedQuantity',
          },
          {
            label: '2Qual.',
            property: 'secondQualityQuantity',
          },
          {
            label: '3Qual.',
            property: 'thirdQualityQuantity',
          },
        ];

        listAux.forEach((auxItem: any) => {
          const values = result.items.map((x: any) => x[auxItem.property]);
          this.dataSourceDefect.dataSet.push({
            seriesName: auxItem.label,
            data: this.getValueOf(values),
          });
        });

        result.items.forEach((a: any) => {
          this.totalDefect += Number(a.totalDefect);
        });
        this.errorApi = false;
      } else {
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALYDEFECT_ORDERCLAS;
        this.errorApi = true;
      }
    } catch (error) {
      this.errorApi = false;
      this.formatErrorMensagem(error.error[0].message);
    } finally {
      if (!this.inValue) {
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALYDEFECT_ORDERCLAS;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_FINALYDEFECT_ORDERCLAS);
      }
      this.loading = false;
    }
  }

  getValueOf(objValue: any): any[] {
    return objValue.map((value: any) => {
      if (value > 0) {
        this.inValue = true;
        return {
          value: value,
        };
      } else {
        return {
          value: value,
          showValue: '0',
        };
      }
    });
  }

  validateFilter(item: any): boolean {
    if (item.typeClassification.length === 0) {
      this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALY_NULLCLASS;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if (item.branch == '') {
      this.message = CONSTANTS.MESSAGES.DATA_BRANCH_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if (item.dateInvalid) {
      this.message = CONSTANTS.MESSAGES.DATA_MIN_INVALID;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    return true;
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem =
      'Arquivo: Finaly-Defect \r\n' +
      'Data: ' +
      dataError +
      '\r\n' +
      'Mensagem: ' +
      item +
      '\r\n' +
      '===============================================' +
      '\r\n';
    this.errorEmitter.emit(errorMensagem);
  }
}
